module.exports = __webpack_public_path__ + "static/media/onboarding-conduct-research.32370f35.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-conduct-research.png
// module id = 1060
// module chunks = 0